<script>
export default {
  data() {
    return {
      seeGroup: false,
    };
  },
  props: {
    group: null
  },
  computed: {
    brands() {
      return this.$store.state.brands;
    },
  },
  methods: {
    close() {
      setTimeout(() => this.seeGroup = false, 50)
    }
  }
};
</script>

<template>
  <section id="job" class="job">
    <div class="container">
      <h2>
        O lugar ideal para profissionais inquietos, criativos e proativos que
        buscam oportunidades de crescimento.
      </h2>
      <hr class="bold" />
    </div>
    <div class="container job__box">
      <div class="job__group"  :class="{active:seeGroup}">
        <ul>
          <li>
            <div>
              <img
                :src="
                  require(`@/assets/images/smart_fit/Logo-smartfit-black.png`)
                "
                alt=""
              />
            </div>

            <div>
              <router-link :to="{name:'jobs.group',params:{group:'smart-fit'}}"> VER OPORTUNIDADES </router-link>
            </div>
          </li>
          <li>
            <div>
              <img
                :src="require(`@/assets/images/smart_fit/Bioritmo_logo.png`)"
                alt=""
              />
            </div>

            <div>
              <router-link :to="{name:'jobs.group',params:{group:'bioritmo'}}"> VER OPORTUNIDADES </router-link>
            </div>
          </li>
          <li>
            <div class="text">
              <h2>
                <strong><i>STUDIOS</i></strong>
              </h2>
            </div>

            <div>
              <router-link :to="{name:'jobs.group',params:{group:'studios'}}"> VER OPORTUNIDADES </router-link>
            </div>
          </li>
        </ul>
      </div>

      <div class="d-flex flex-wrap flex-lg-nowrap w-100">
        <div class="job__box__card">
          <div class="bg bg1"></div>
          <div class="text d-flex flex-column align-items-center">
            <h3>
              Vagas em <br />
              academias
            </h3>
            <button  @click="seeGroup = !seeGroup" @blur="close()" class="btn--job">
              VER OPORTUNIDADES
            </button>
          </div>
        </div>

        <div class="job__box__card">
          <div class="bg bg2"></div>
          <div class="text d-flex flex-column align-items-center">
            <h3>
              Vagas <br />
              corporativas
            </h3>
            <button @click="$router.push({name:'jobs.group',params:{group:'corporativas'}})" class="btn--job">VER OPORTUNIDADES</button>
          </div>
        </div>

        <div class="job__box__card">
          <div class="bg bg3"></div>
          <div class="text d-flex flex-column align-items-center">
            <h3>
              Vagas para <br />
              pessoas com deficiência
            </h3>
            <button @click="$router.push({ name: 'jobs.group', query: { pcd: true } })" class="btn--job">VER OPORTUNIDADES</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped src="../styles/job.scss"></style>